import * as React from 'react'
import * as Styles from './SharePopWindow.style'
import success_ico from '../../../../assets/share_finish.png'
//  tslint:disable-next-line
const qr = require('qr-encode')

interface ISharePopWindowState {
    shareQrcode: string,
    hideFloatWindow: () => void | null
}

export default class SharePopWindow extends React.Component  <ISharePopWindowState> {
    public render() {
        return (
            <div className={Styles.SharePopWindow}>
                <div className={Styles.SharePopWindowMask} onClick={this.props.hideFloatWindow}/>
                <div className={Styles.SharePopWindowWrap}>
                    <div className={Styles.SharePopWindowTop}>
                        <img className={Styles.SharePopWindowTopImg} src={success_ico}/>
                        <div>
                            分享成功
                        </div>
                    </div>
                    <div className={Styles.SharePopWindowMiddle}>
                        <div className={Styles.SharePopWindowMiddleImgBox}>
                            <img src={qr(this.props.shareQrcode)}/>
                        </div>
                        <div>
                            长按扫码关注，听课赚钱两不误
                        </div>
                    </div>
                    <div className={Styles.SharePopWindowBottom} onClick={this.props.hideFloatWindow}>
                        <div className={Styles.SharePopWindowBottomLine}/>
                        <div className={Styles.SharePopWindowBottomText}>
                            关闭
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/views/FreeLecture/components/SharePopWindow/SharePopWindow.tsx